<form autocomplete="off" class="form" (submit)="onSubmit($event)">
  <div class="field is-narrow">
    <label
      class="label"
      translationEditableDirective="TWO_FACTOR_AUTH_ENABLED"
      >{{ 'TWO_FACTOR_AUTH_ENABLED' | translate }}</label
    >
    <div class="control">
      <chip
        [checked]="getField(['twoFactorAuthEnabled'])"
        (onChange)="checkboxChange($event, 'twoFactorAuthEnabled')"
        [value]="!getField(['twoFactorAuthEnabled'])"
      >
        <span
          [translationEditableDirective]="
            getField(['twoFactorAuthEnabled']) ? 'ENABLED' : 'DISABLED'
          "
        >
          {{
            (getField(['twoFactorAuthEnabled']) ? 'ENABLED' : 'DISABLED')
              | translate
          }}
        </span>
      </chip>
    </div>
    <p class="help is-danger" *ngIf="hasError('twoFactorCodeLength')">
      {{ getError('twoFactorCodeLength') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label
      class="label"
      translationEditableDirective="TWO_FACTOR_CODE_LENGTH"
      >{{ 'TWO_FACTOR_CODE_LENGTH' | translate }}</label
    >
    <div class="control">
      <input
        class="input"
        name="twoFactorCodeLength"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['twoFactorCodeLength'])"
        [ngClass]="{ 'is-danger': hasError('twoFactorCodeLength') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('twoFactorCodeLength')">
      {{ getError('twoFactorCodeLength') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label
      class="label"
      translationEditableDirective="TWO_FACTOR_CODE_VALIDITY_MS"
      >{{ 'TWO_FACTOR_CODE_VALIDITY_MS' | translate }}.</label
    >
    <div class="control">
      <input
        class="input"
        name="twoFactorCodeValidityMs"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['twoFactorCodeValidityMs'])"
        [ngClass]="{ 'is-danger': hasError('twoFactorCodeValidityMs') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('twoFactorCodeValidityMs')">
      {{ getError('twoFactorCodeValidityMs') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label
      class="label"
      translationEditableDirective="INACTIVITY_TIMER_ENABLED"
      >{{ 'INACTIVITY_TIMER_ENABLED' | translate }}</label
    >
    <div class="control">
      <chip
        [checked]="getField(['inactivityTimerEnabled'])"
        (onChange)="checkboxChange($event, 'inactivityTimerEnabled')"
        [value]="!getField(['inactivityTimerEnabled'])"
      >
        <span
          [translationEditableDirective]="
            getField(['inactivityTimerEnabled']) ? 'ENABLED' : 'DISABLED'
          "
        >
          {{
            (getField(['inactivityTimerEnabled']) ? 'ENABLED' : 'DISABLED')
              | translate
          }}
        </span>
      </chip>
    </div>
    <p class="help is-danger" *ngIf="hasError('twoFactorCodeLength')">
      {{ getError('inactivityTimerEnabled') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label
      class="label"
      translationEditableDirective="INACTIVITY_TIMER_VISIBILITY"
      >{{ 'INACTIVITY_TIMER_VISIBILITY' | translate }}</label
    >
    <div class="control">
      <chip
        [checked]="getField(['inactivityTimerDisplay'])"
        (onChange)="checkboxChange($event, 'inactivityTimerDisplay')"
        [value]="!getField(['inactivityTimerDisplay'])"
      >
        <span
          [translationEditableDirective]="
            getField(['inactivityTimerDisplay']) ? 'VISIBLE' : 'HIDDEN'
          "
        >
          {{
            (getField(['inactivityTimerDisplay']) ? 'VISIBLE' : 'HIDDEN')
              | translate
          }}
        </span>
      </chip>
    </div>
    <p class="help is-danger" *ngIf="hasError('twoFactorCodeLength')">
      {{ getError('inactivityTimerDisplay') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label
      class="label"
      translationEditableDirective="INACTIVITY_TIMER_TIMEOUT_MS"
      >{{ 'INACTIVITY_TIMER_TIMEOUT_MS' | translate }}.</label
    >
    <div class="control">
      <input
        class="input"
        name="inactivityTimerTimeoutMs"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['inactivityTimerTimeoutMs'])"
        [ngClass]="{ 'is-danger': hasError('inactivityTimerTimeoutMs') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('inactivityTimerTimeoutMs')">
      {{ getError('inactivityTimerTimeoutMs') }}
    </p>
  </div>

  <div class="field is-grouped">
    <div class="control">
      <button
        [disabled]="isLoading"
        type="submit"
        class="button is-link"
        translationEditableDirective="SAVE"
      >
        {{ 'SAVE' | translate }}
      </button>
    </div>
  </div>
</form>
